import can from 'can';

export const BaseMap = can.Map.extend({
    setup: function () {
        can.Map.setup.apply(this, arguments);
        this.List = can.List({
            Map: this
        }, {});
    }
},{
    //
});
